import React from "react";
import { ErrorMessage } from "../atoms";
import { FieldError } from "react-hook-form";
import { isDefined } from "@centisystems/lib/utils";

export default function FieldErrorMessage({
  error,
  space = false,
  className,
}: {
  error: FieldError | undefined;
  space?: boolean;
  className?: string;
}) {
  return (
    isDefined(error) && (
      <ErrorMessage className={`${className} ${space && "pt-2"}`}>
        {error?.message}
      </ErrorMessage>
    )
  );
}
